<template>
  <div class="test_info">
    <van-popup v-model="show" :close-on-click-overlay="false">
      <div class="info_content">
        <div class="title">{{ item.name }}</div>
        <div class="info">
          <div class="li">考试时长：{{ item.duration || 0 }}分钟</div>
          <div class="li">试题数量：{{ item.questionCount || 0 }}题</div>
          <div class="time">
            <div>
              考试时间：<span v-if="item.terminationFlag === 1"
                >工作人员终止了考试</span
              >
            </div>
            {{ item.startTime }}-{{ item.endTime }}
          </div>
          <div class="btn">
            <van-button
              class="angin"
              @click="restartChallenge"
              v-if="
                item.repetitionTestFlag &&
                  item.testingFlag === 2 &&
                  item.userTestingFlag
              "
              >重新挑战</van-button
            >
            <van-button
              class="achievement"
              v-if="item.userTestingFlag"
              :disabled="!item.openPerformanceFlag"
              @click="viewResult"
              >{{
                item.openPerformanceFlag ? "查看成绩" : "不公开成绩"
              }}</van-button
            >
            <van-button
              class="into"
              v-if="!item.userTestingFlag && item.testingFlag !== 3"
              :disabled="item.testingFlag === 1"
              @click="intoExam"
              >{{
                item.testingFlag === 1 ? "考试未开始" : "进入考场"
              }}</van-button
            >
            <van-button
              class="end"
              v-if="item.testingFlag === 3 && !item.userTestingFlag"
              >考试已结束</van-button
            >
          </div>
        </div>
        <div class="close" @click="show = false">
          <img src="./img/close.png" alt="" />
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script>
import { Popup as VanPopup, Button as VanButton, Toast } from "vant";
import { obj2StrParams, dataBurialPoint } from "@/utils/common";
export default {
  data() {
    return {
      show: false,
      item: {}
    };
  },
  methods: {
    init(item = {}) {
      this.show = true;
      this.item = item;
      this.item.startTime = this.item.startTime.replace(
        new RegExp("-", "g"),
        "."
      );
      this.item.endTime = this.item.endTime.replace(new RegExp("-", "g"), ".");
    },
    dataBurialPoint(page, event) {
      dataBurialPoint(page, event);
    },
    //查看成绩
    viewResult() {
      if (!this.item.openPerformanceFlag) {
        Toast("本场考试不开放成绩");
        return;
      }
      this.dataBurialPoint("A001", "A001-004-03");
      let params = obj2StrParams({
        testPaperId: this.item.testPaperId,
        testPaperNo: this.item.testPaperNo,
        testingId: this.item.id
      });
      this.show = false;
      window.location.href = "./topicExamResult.html" + params;
    },
    //进入考场
    intoExam() {
      if (this.item.testingFlag === 1) {
        Toast("考试时间未到");
        return;
      }
      if (this.item.testingFlag === 3) {
        Toast("考试时间已结束");
        return;
      }
      if (this.item.terminationFlag === 1) {
        Toast("工作人员终止了考试");
        return;
      }
      this.dataBurialPoint("A001", "A001-004-01");
      let params = obj2StrParams({
        testPaperId: this.item.testPaperId,
        testPaperNo: this.item.testPaperNo,
        testingId: this.item.id,
        againFlag: 0
      });
      this.show = false;
      //跳转考试须知
      window.location.href = "./testInstructions.html" + params;
    },
    //重新挑战
    restartChallenge() {
      if (this.item.terminationFlag === 1) {
        Toast("工作人员终止了考试");
        return;
      }
      this.dataBurialPoint("A001", "A001-004-02");
      let params = obj2StrParams({
        testPaperId: this.item.testPaperId,
        testPaperNo: this.item.testPaperNo,
        testingId: this.item.id,
        againFlag: 1
      });
      this.show = false;
      //跳转考试须知
      window.location.href = "./testInstructions.html" + params;
    }
  },
  components: {
    VanPopup,
    VanButton
  }
};
</script>
<style lang="scss">
.test_info {
  .van-popup {
    font-family: Source Han Sans CN;
    width: 78%;
    background: linear-gradient(0deg, #fffaf3, #ffffff);
    box-shadow: 0px 5px 15px 0px rgba(0, 0, 0, 0.08);
    border-radius: 5px;
    overflow: inherit;
  }
  .info_content {
    position: relative;
  }
  .title {
    padding: 21px 13px 11px;
    text-align: center;
    font-size: 18px;
    font-weight: bold;
    color: #4d310b;
    line-height: 24px;
  }
  .info {
    padding: 0 16px;
  }
  .li {
    width: 100%;
    height: 40px;
    background: #ffffff;
    border: 1px solid #dcd1c2;
    border-radius: 2px;
    line-height: 40px;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #333333;
    padding-left: 11px;
    margin-bottom: 11px;
  }
  .time {
    border: 1px solid #dcd1c2;
    border-radius: 2px;
    background: #ffffff;
    width: 100%;
    font-size: 12px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #666666;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 11px;
    margin-bottom: 18px;
    div {
      font-size: 14px;
      color: #333333;
      display: flex;
      align-items: center;
      span {
        font-size: 12px;
        font-family: Source Han Sans CN;
        font-weight: 500;
        color: #ff4444;
      }
    }
  }
  .btn {
    display: flex;
    justify-content: center;
    margin-bottom: 24px;
    .van-button {
      flex: 1;
      height: 42px;
      line-height: 42px;
      border-radius: 2px;
      font-size: 16px;
      font-family: Source Han Sans CN;
      font-weight: 500;
      border: none;
      box-sizing: border-box;
      &:not(:first-child) {
        margin-left: 15px;
      }
    }
    .achievement,
    .into {
      background: #ff4444;
      color: #ffffff;
    }
    .angin {
      background: #ffffff;
      border: 1px solid #ff4444;
      border-radius: 2px;
      color: #ff4444;
    }
    .end {
      background: #e5e5e5;
      color: #999999;
    }
  }
  .close {
    position: absolute;
    bottom: -86px;
    left: 50%;
    transform: translateX(-50%);
    img {
      width: 36px;
    }
  }
}
</style>
